import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { ORIG } from "../mock";

/**
 * Card grid linking to related inner pages.
 * Pass `current` (route) to exclude that page from the list.
 */
const ALL = [
  { key: "/know-us.html", label: "Know Us", italic: "the school", image: 'https://customer-assets.emergentagent.com/job_goenkasig-new/artifacts/zru1r8e7_455.jpg' },
  { key: "/montessori.html", label: "Montessori", italic: "early years", image: `${ORIG}/banner-montesari.jpg` },
  { key: "/real-world.html", label: "Real World", italic: "curriculum\u2122", image: `${ORIG}/banner-rwc.jpg` },
  { key: "/examination.html", label: "Examination", italic: "system", image: `${ORIG}/examination.jpg` },
  { key: "/junior-school.html", label: "Junior School", italic: "pre\u2011nursery \u2014 class 2", image: '/junior/clean/p24.jpg' },
  { key: "/our-campus.html", label: "Our Campus", italic: "20\u2011acre signature", image: `${ORIG}/home-banner.webp` },
  { key: "/best-boarding-school-in-india.html", label: "Boarding", italic: "day, weekly, full", image: `${ORIG}/banner-boarding1.webp` },
  { key: "/sports.html", label: "Sports", italic: "on the field", image: `${ORIG}/banner-sport.jpg` },
  { key: "/arts.html", label: "Arts", italic: "a cultural hub", image: `${ORIG}/beyond-acedemic-home-th.webp` },
  { key: "/admissions.html", label: "Admissions", italic: "2026 \u2014 2027", image: `${ORIG}/home-banner2.webp` },
  { key: "/gallery.html", label: "Gallery", italic: "at a glance", image: `${ORIG}/bg_1-min.jpg` },
  { key: "/contact-us.html", label: "Contact", italic: "reach out", image: `${ORIG}/home-banner1a.webp` },
];

export default function RelatedPages({ current, picks }) {
  // If picks provided, use them; otherwise pick 3 sequential others
  let items;
  if (picks && picks.length) {
    items = picks.map((k) => ALL.find((a) => a.key === k)).filter(Boolean);
  } else {
    const idx = ALL.findIndex((a) => a.key === current);
    const all = ALL.filter((a) => a.key !== current);
    if (idx >= 0) {
      items = [
        ALL[(idx + 1) % ALL.length],
        ALL[(idx + 2) % ALL.length],
        ALL[(idx + 3) % ALL.length],
      ].filter((x) => x.key !== current);
    } else {
      items = all.slice(0, 3);
    }
  }
  items = items.slice(0, 3);

  return (
    <section className="bg-[var(--cream)] py-14 md:py-20">
      <div className="max-w-[1300px] mx-auto px-5 md:px-10">
        <Reveal>
          <div className="text-center max-w-[700px] mx-auto mb-10 md:mb-12">
            <div className="eyebrow mb-4">Explore more</div>
            <h2 className="h-section text-[var(--ink)]">
              Continue your
              <span className="serif-italic gold-text"> journey.</span>
            </h2>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {items.map((it, i) => (
            <Reveal key={it.key} variant="zoom" delay={i * 120}>
              <Link to={it.key} className="group block">
                <div className="relative aspect-[4/3] overflow-hidden bg-[var(--navy)]">
                  <img src={it.image} alt={it.label} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[rgba(6,13,34,0.85)] via-[rgba(6,13,34,0.15)] to-transparent" />
                  <div className="absolute inset-0 ring-1 ring-[rgba(184,148,86,0.0)] group-hover:ring-[rgba(184,148,86,0.65)] transition-all duration-500" />
                  <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between gap-3">
                    <div>
                      <div className="serif text-white text-[24px] md:text-[28px] leading-tight">
                        {it.label}
                        <span className="block serif-italic gold-text text-[15px] md:text-[16px] mt-0.5">{it.italic}</span>
                      </div>
                    </div>
                    <span className="w-10 h-10 rounded-full border border-[var(--gold)] flex items-center justify-center text-[var(--gold)] group-hover:bg-[var(--gold)] group-hover:text-[var(--navy-deep)] transition-all duration-300 shrink-0">
                      <ArrowUpRight size={16} />
                    </span>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
